import { render, staticRenderFns } from "./PRODES.vue?vue&type=template&id=5af3f30f&lang=pug"
import script from "./PRODES.vue?vue&type=script&lang=js"
export * from "./PRODES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports